import { backendURL } from '../services/http';

/**
 * Sunucudan gelen medya yolunu tarayıcının açabileceği adrese çevirir.
 *
 * Backend iki farklı şekil üretiyor ve ikisi de canlıda dolu:
 *   - GÖRELİ  `/uploads/products/OZL-056_1757.jpg` — bizim yüklediğimiz dosyalar
 *     (`uploadMiddleware.processAndSaveImage` bu şekli döndürür). Tarayıcı bunu
 *     tek başına çözemez, önüne sunucunun adresi gerekir.
 *   - MUTLAK  `https://cdn.shopify.com/...` — Shopify'dan adresiyle gelen ürün
 *     görselleri. Bunlara DOKUNULMAZ; önek eklemek adresi bozar.
 *
 * Adres `http.ts`'ten okunur, `process.env`'den DEĞİL. `http.ts` canlıda ortam
 * değişkenini bilerek yok sayıp `window.location.origin` kullanıyor ("production'da
 * .env kazalarını %100 engeller"); burada `REACT_APP_API_URL`'i doğrudan okumak o
 * korumanın etrafından dolaşır ve sunucudaki .env satırı silindiği gün 147 ürünün
 * görselini sessizce yok eder (rota 2.7).
 *
 * '' → '' döner: çağıran zaten "değer var mı" kontrolünü kendi yapıyor, burada
 * boş değere önek eklemek `https://crm.triocare.com.tr` gibi anlamsız bir adres üretirdi.
 *
 * Not: avatar adreslerindeki `?v=` önbellek kırıcısı çağıranda kalır — o adres
 * kurma işi değil, tazeleme işi ve yalnız avatarda var.
 */
export const mutlakMedyaUrl = (yol: string | null | undefined): string => {
  if (!yol) return '';
  return yol.startsWith('/') ? `${backendURL}${yol}` : yol;
};
